import { KpiConfigurationFieldName } from "@app/pages/kpi-configuration/kpi-configuration.constant";
import { CommonEditContext, CommonSearchContext, CommonSearchCriteriaModel } from "./common-data.model";
import { DriverDataBusinessType } from "@shared/enums";

export const DefaultKpiConfigurationModel = {
  search: {
    searchForm: {
      model: {
        searchCriteria: [{
          searchBy: KpiConfigurationFieldName.businessType,
          searchValue: DriverDataBusinessType.LB_MB,
          isSearchByDisabled: true
        }]
      } as CommonSearchCriteriaModel,
      dirty: false,
      status: null as any,
      errors: null as any,
    }
  } as CommonSearchContext,
  edit: {
    editForm: {
      model: {} as KpiConfigurationEditCriteria,
      dirty: false,
      status: null as any,
      errors: null as any
    },
  } as CommonEditContext<KpiConfigurationEditCriteria>,
}

export interface KpiConfigurationEditCriteria {
  kpiConfiguration_Id: number;
  weight: number;
}
